function isObject(v) {
  return Object.prototype.toString.call(v) === "[object Object]";
}

function filterEmptyQuery(params) {
  const ps = {};
  Object.keys(params).forEach(k => {
    if (params[k] !== undefined && params[k] !== null && params[k] !== "") {
      ps[k] = params[k];
    }
  });
  return ps;
}

function formatNumberIn(obj) {
  const tmpObj = Object.assign({}, obj);
  Object.keys(tmpObj).forEach(key => {
    const curVal = tmpObj[key];
    if (typeof curVal === Number) {
      tmpObj[key] = `$${curVal}`;
    }
  });
  return tmpObj;
}

function formatNumberOut(obj) {
  const tmpObj = Object.assign({}, obj);
  Object.keys(tmpObj).forEach(key => {
    const curVal = String(tmpObj[key]);
    if (curVal !== "" && curVal.indexOf("$") === 0) {
      const val = Number(curVal.replace(/\$/, ""));
      if (!isNaN(val)) {
        tmpObj[key] = val;
      }
    }
  });
  return tmpObj;
}

export default {
  install: function(Vue) {
    Vue.prototype.$getFromCache = function() {
      return formatNumberOut(this.$route.query);
    };

    Vue.prototype.$setFromCache = function(values, isFilterNull) {
      if (!isObject(values)) {
        return false;
      }
      const query = isFilterNull ? filterEmptyQuery(values) : values;
      this.$router.replace({ query: formatNumberIn(query) });
    };
  }
};
